import * as React from "react";
import { MicButton } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

/**
 * Interactive mic — toggles `listening` on click so the icon swap (Mic ↔ MicOff),
 * the destructive listening tint, and the springy press all read live.
 */
function ToggleMic() {
  const [listening, setListening] = React.useState(false);
  return <MicButton listening={listening} onClick={() => setListening((v) => !v)} />;
}

export function MicButtonDemo() {
  return (
    <Section
      id="mic-button"
      title="MicButton"
      description="Round voice-input affordance — a thin wrapper over Button (size=icon, variant=ghost). Idle reads muted; listening swaps Mic → MicOff and tints destructive (the click means 'stop recording'). It's a ROUND control, so it keeps its circle rather than the hex notch, but still shares the Onyx offset-key feel: a springy 1px press-DOWN on :active. Controlled via the `listening` prop; aria-pressed + a listening-aware aria-label come for free."
    >
      <VariantBlock label="States">
        <MicButton listening={false} />
        <MicButton listening={true} />
      </VariantBlock>

      <VariantBlock label="Interactive" caption="click to toggle listening">
        <ToggleMic />
      </VariantBlock>

      <VariantBlock label="Disabled">
        <MicButton listening={false} disabled />
        <MicButton listening={true} disabled />
      </VariantBlock>

      <VariantBlock label="Custom labels">
        <MicButton listening={false} startLabel="Dictate note" stopLabel="Stop dictation" />
      </VariantBlock>
    </Section>
  );
}
